/**
 * Exists to constrain what endpoints can be provided to the context object in Apollo requests.
 */
export const enum Endpoints {
  APPSYNC = "appsync",
  BACKEND = "backend",
  SPRING_BFF = "springBff"
}
